import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconSuccessComponent } from "./med-icon-success.component";

@NgModule({
  declarations: [
    MedIconSuccessComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconSuccessComponent,
  ],
})
export class MedIconSuccessModule { }
